import { FindFormatCommand, FindMeasureCommand, FindStyleCommand, FreedataCall, MeasureParams, UserContextService } from '@wizeoo/akm-common-lib';
import { ChangeDetectorRef, Component, ComponentRef, ElementRef, ViewChild, ViewContainerRef } from '@angular/core';
import { WIZ_COMMAND_STATE, WIZ_EVENT_TYPE,  
  CONFIRMATION_MODE, CONFIRMATION_RESULT, FILTER_TYPE, WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import {
  ConfirmationResultObj,
  FilterComponent,
  FilterObj,
  WizActionObj,
  WizButton,
  WizCommand,
  WizComponentManager,
  WizDatasource,
  WizDropdown,
  WizGroupCommand,
  WizPopUp,
  WizRoot,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { ChronocodeCmd } from '@wizeoo/akm-common-lib';
import { MultiDisplay, MultiDisplayConfig } from '@wizeoo/akm-common-lib';
import { AgLabelValidityRenderer } from '@wizeoo/akm-common-lib';
import { AlkEvent, Color, colorSets } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { BATCH_KIND } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { ViewData } from '@wizeoo/akm-common-lib';
import { MeasureRightPop } from './pops/measure-right-pop';
import { MeasureTreeRenderer } from './renderers/measure-tree.renderer';
import { MeasMode, MeasureVO, VisionVO, WizConstants } from '@wizeoo/akm-compute-lib';
import { VisionStepVO } from '@wizeoo/akm-common-lib';
import { MeasureKindRenderer } from '@wizeoo/akm-common-lib';
import { FormulaEditorPop } from '@wizeoo/akm-common-lib';

/**
 * Ecran de gestion des mesures de la BU / domain
 */
@Component({
  selector: 'measure-view',
  templateUrl: './measure.view.html',
})
export class MeasureView extends BaseView {
  @ViewChild('canvas', { static: true }) canvas: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasDot', { static: true }) canvasDot: ElementRef<HTMLCanvasElement>;
  @ViewChild('canvasLeft', { static: true }) canvasLeft: ElementRef<HTMLCanvasElement>;
  // container HTML pour chargement des canvas
  @ViewChild('canvasContainer', { read: ViewContainerRef, static: true }) canvasContainer: ViewContainerRef;
  // compo multidisplay( liste gauche)
  @ViewChild('multiDisp', { read: MultiDisplay, static: false }) multiDisp: MultiDisplay<MeasureVO>;
  // @ViewChild('btnAddMeasure', {read: WizButton}) btnAddMeasure: WizButton;
  // @ViewChild('btnRemove', { read: WizButton }) btnRemove: WizButton;
  @ViewChild('ddStep', { read: WizDropdown, static: false }) ddStep: WizDropdown; // drop de sélection du step

  constructor(public elementRef: ElementRef, private cdref: ChangeDetectorRef) {
    super(elementRef);
  }

  private get _context(): UserContextService {
    return this.model.userContextService;
  }

  /**
   * configuration de l'affichage en multi liste
   */
  public multiDisplayConfig: MultiDisplayConfig<MeasureVO> = {
    model: Model.getInstance(),
    datasource: this.model.measureDS,
    defaultMode: 'grid',
    // onSelectionChanging: this.onWizEventSelectionChange.bind(this),
    onSelectionChanged: this.onWizEventSelectionChange.bind(this),
    tiles: { enabled: false, renderer: null },
    grid: {
      rowSelection: 'multiple',
      enabled: true,
      columns: [
        { headerName: ' ', field: 'mode', width: 30, cellRenderer: 'kindRenderer', sortable: true },
        { headerName: ' ', field: 'shortCode', 
          valueGetter: this.getStepOverride.bind(this),
          tooltipValueGetter: this.getStepOverride.bind(this),
          width: 60, sortable: true
        },
        { headerName: '$.common.code.$', field: 'shortCode',  width: 100, sortable: true, resizable: true },
        {
          headerName: '$.common.label.$',
          field: 'trsLabel',
          width: 180,
          cellRenderer: 'labelRenderer',
          sortable: true, resizable: true
        },
        {
          headerName: '$.common.description.$',
          field: 'trsDesc',
          width: 200,
          sortable: false, resizable: true
        },
        // { headerName: '$.common.code.$', field: 'code', width: 150},
        { headerName: '$.mesure.formula.i.$', field: 'formulaI', width: 150, resizable: true },
        { headerName: '$.mesure.formula.s.$', field: 'formulaS', width: 150, resizable: true },
        { headerName: '$.mesure.formula.f.$', field: 'formulaF', width: 150 },
        { headerName: '$.mesure.formula.t.$', field: 'formulaT', width: 150 },
      ],
      renderers: {
        labelRenderer: AgLabelValidityRenderer,
        kindRenderer: MeasureKindRenderer,
       },
      suppressRowClickSelection: true,
      rowClassRules: {
        'force-row-background': this.highlightSelectedMeasure.bind(this), // couleur de rendu de la mesure sélectionnée
      }
    },
    filter: {
      enabled: true,
      initFilter: this.initFilter.bind(this),
    }
  };


  /** forcer la colorisation de la ligne de mesure active */
  private highlightSelectedMeasure(params: any): boolean {
    return params.data === this.model.currentMeasure;
  }

  // retourne les fonctions métier (mode FIST en haut à droite)
  public wizMainActions(): WizActionObj[] {
    // return null;
    return [
      new WizActionObj('F', null, this.showMode.bind(this), WizButton, false, null, '24px', '24px', 'F'),
      new WizActionObj('I', null, this.showMode.bind(this), WizButton, false, null, '24px', '24px', 'I'),
      new WizActionObj('T', null, this.showMode.bind(this), WizButton, false, null, '24px', '24px', 'T'),
      new WizActionObj('S', null, this.showMode.bind(this), WizButton, false, null, '24px', '24px', 'S'),
    ];
  }

  /** steps de la vision en cours pour alimentation de la combo de simulation */
  public visionStepsSimulation: WizDatasource<VisionStepVO> = new WizDatasource<VisionStepVO>([])
    .setSortFields([{ property: 'level', way: 'asc', numeric: true }])
    .build();

  /** constante de structure pour dessiner les thumbs */
  public baseWidth: number = 220; // largeur standard
  public baseHeight: number = 100; // taille standard des thumbs
  public smallHeight: number = 50; // taille de la première ligne (pas de dépendances)
  public baseHGap: number = 20; // gap horizontal entre les thumbs
  public baseVGap: number = 20; // gap vertical entre les thumbs

  public rowLineOffset: number = 2; // * level-1 décalage de positionnement de l'accroche de départ des lignes (pour éviter les superpositions)
  public levelHGap: number = 100; // * level-1 décalage de positionnement de l'accroche de départ des lignes (pour éviter les superpositions)
  public maxPerColumn: number = 9; // nombre maximal d'éléments par ligne

  private nextX: number = 0; // position verticale de la prochaine ligne à dessiner

  // public lineColors: string[] = ['#5A4176', '#79589F', '#d3a918', '#FF0000', '#00FF00'];
  private scheme: Color = colorSets[0]; // jeu de couleur
  private itemIdx: number = 1; // l'item en cours de liaison (couleur des liens)
  // private buildOK: boolean = false; // flag pour neutraliser les event du multidisplay sur les sélections initiales

  /**
   * map des MeasureTree pour dessiner les flèches / calculer les distances
   * Map[MeasureKey(sans le mode)] = [le compo, originX, originY, width, height, offset origine lignes]
   */
  private thumbMap: Map<string, [ComponentRef<MeasureTreeRenderer>, number, number, number, number, number]> = new Map<
    string,
    [ComponentRef<MeasureTreeRenderer>, number, number, number, number, number]
  >();

  /**
   * Override sur before init pour alimentation measures et codifs
   */
  wizBeforeInit(): WizGroupCommand | boolean {
	super.wizBeforeInit();
    const commands: WizCommand<any>[] = [];

    // disponibilité des chronocodes pour labels
    if (!this.model.chronocodeEngine.getChronocodesMap()) {
      commands.push(new ChronocodeCmd(Model.getInstance()).find());
    }
    // disponibilité des freedatas pour labels
    if (!this.model.freedataEngine.getFreedataMap()) {
      commands.push(new FreedataCall(Model.getInstance()));
    }
    // chargement systématique de la liste des mesures
    // if (!this.model.measureList) {
    commands.push(new FindMeasureCommand(Model.getInstance()));
    // }
    // vérification des styles
    if (!this.model.styleList) {
      commands.push(new FindStyleCommand(Model.getInstance()));
    }

    // chargement de la liste des formats
    if (!this.model.formatEngine.getFormatList()) {
      // TODO, double appel pour format de base à la bu (*)
      commands.push(new FindFormatCommand(Model.getInstance()).find(ViewData.wildcardDomain, ViewData.wildcardDomain));
      commands.push(new FindFormatCommand(Model.getInstance()).find(this.model.domainCode, this.model.businessUnitCode));
    }

    return commands.length ? new WizGroupCommand().configure(commands) : true;
  }

  public wizSynchronizeData(): void {
    // pas de vrai fonction dans le corps de vue, tout est dans le rightPanel
    // super.managePermissions([
    //   {
    //     feature: StaticFeatureEnum.MEASURE,
    //     permissions: [
    //       {            component: this.btnAddMeasure,
    //         accesses: [PermissionAccess.CREATE],
    //         visibility: PermissionVisibility.DISABLED
    //       },
    //       {
    //         component: this.btnRemove,
    //         accesses: [PermissionAccess.DELETE],
    //         visibility: PermissionVisibility.DISABLED
    //       }
    //     ]
    //   }
    // ]);
    this.feed();
  }

  /** alimentation de la vision */
  public feed(e: WizEvent = null): void {
    this.model.measureEngine.clearFEI();
    
    const vision: VisionVO = this.model.currentVision; // alimentation des steps de la vision
    if (!!vision?.visionSteps) {
      this.visionStepsSimulation.setSource(Object.values(vision.visionSteps || {}).map(item => new VisionStepVO(item)));
    } else {
      this.visionStepsSimulation.setSource([]);
    }

    this.visionStepsSimulation.clearSelection();

    // this.mainDS.clearSelection();

    this.model.measureDS.clearSelection();
    this.model.currentMeasure = null; // clear de la sélection
    this.model.currentStepLevel = 0; // par défaut, mesures de la vision

    this.feedByStepLevel(); // alimentation de la liste de mesures concernées
  }

  /**
   * choix d'un step pour affichage de ses mesures
   * @param e wizEvent Change sur la ddStep
   */
  private selectStep(e: WizEvent): void {
    if (!!this.visionStepsSimulation.selectedItem) {
      this.model.currentStepLevel = this.visionStepsSimulation.selectedItem.level;
    } else {
      this.model.currentStepLevel = 0;
    }
    this.model.measureEngine.clearFEI();

    this.feedByStepLevel();
    this.showOrHideEditionPop(); // refresh de la popUp
  }

  /**
   * alimentation de la liste de mesures et construction de la matrice de calcul
   */
  public feedByStepLevel(): void {
    this.model.measureEngine.buildDS(this.model.visionCode, this.model.currentStepLevel); // Alimentation de la liste des mesures
    
    this.model.measureEngine.buildFeiMatrix(this.model.measureEngine.currentFEI);
    const selectedMeasure: MeasureVO = this.model.currentMeasure;
    if (selectedMeasure) {
      // une mesure sélectionnée, on prend le bon stepLevel
      this.model.currentMeasure = this.model.measureEngine.getMeasure(
        selectedMeasure.vision,
        this.model.currentStepLevel,
        selectedMeasure.shortCode
      );
    }

    this.buildFilter(); // construction du mainFilter

    setTimeout(() => {
      this.buildGraph(); // construction de la zone de dessin des thumbs
    }, 0);
  }

  public wizAddListener(): void {
	super.wizAddListener();
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.SELECT_VISION, this.feed); // modification de la portée vision au niveau de l'appli, rechargement
    WizEventManager.addListener(this, this.ddStep, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.selectStep); // choix d'un niveau de step

    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_SET_MODE, this.setMeasureMode); // changer de mode FIST
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_DEPENDENCY, this.setDependency);
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_LEGACY, this.setLegacy);
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_SELECT, this.selectMeasure); // sélection d'une mesure depuis le graph
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_RECOMPUTE, this.recompute); // refresh sur modif de formule
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_DELETE, this.deleteMeasureStep); // refresh sur modif de formule



    // WizEventManager.addListener(this, this.btnAddMeasure,  WIZ_EVENT_TYPE.CLICK, this.askForAdd);
    WizEventManager.addListener(this, this.multiDisp, WIZ_EVENT_TYPE.GRID_ROW_CLICKED, this.setSelected); // supprimer une mesure du graph / ajout depuis le grid
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_SHOW_HIDE, this.onMatrixSelectionChange); // modification de la visibilité depuis la matrice
    WizEventManager.addListener(
      this,
      WizRoot.root(),
      ALK_EVENT_TYPE.MEASURE_SHOW_FORMULA_EDITOR,
      this.showFormuleEditor
    ); // demande d'ouverture de la popUp d'édition de formule

    // écoute du retour d'import (batch pour refresh de la vue)
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN, this.backFromImport);

  }

  public wizRemoveListener(): void {
	super.wizRemoveListener();
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.SELECT_VISION); // modification de la portée vision au niveau de l'appli, rechargement
    WizEventManager.removeListener(this, this.ddStep, WIZ_EVENT_TYPE.SELECTION_CHANGED); // choix d'un niveau de step

    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_SET_MODE);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_DEPENDENCY);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_LEGACY);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_SELECT);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_RECOMPUTE);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_DELETE); // refresh sur modif de formule


    // WizEventManager.removeListener(this, this.btnAddMeasure,  WIZ_EVENT_TYPE.CLICK);
    WizEventManager.removeListener(this, this.multiDisp, WIZ_EVENT_TYPE.GRID_ROW_CLICKED); // supprimer une mesure du graph / ajout depuis le grid
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_SHOW_HIDE);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.MEASURE_SHOW_FORMULA_EDITOR);
    
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN);
  }

  public doAct(action: string): void {
    const hasPendingChanges = ViewData.wizUpdateModel;
    switch (action) {
      case 'export':
        this.model.batchEngine.export(BATCH_KIND.MEASURE, null, this.model.visionCode);
        break;
      case 'import':
        this.model.batchEngine.import(BATCH_KIND.MEASURE);
        break;
    }
  }


  private deleteMeasureStep(e: AlkEvent): void {
    this.recompute(e);
  }



  /**
   * recalcul de la matrice et regen du graph
   * @param e event dispatché par la pop
   */
  private recompute(e: AlkEvent): void {
    
    // refresh du grid de sélection 
    this.model.measureDS.refresh();

    const sourceMeasures: MeasureVO[] = this.model.visionMeasures;
    this.model.measureEngine.currentFEI.model.measureEngine.buildFeiMatrix(this.model.measureEngine.currentFEI);
    // MeasureManager.getInstance().buildMatrix(MeasureManager.getInstance().currentFEI, sourceMeasures);
    this.showOrHideEditionPop(); // refresh de la popUp
    this.buildGraph();

    // suppression des FEI chargés
    this.model.dataEngine.resetDatas();

    // synchro de la vision en cours et de ses steps
    this.model.currentVision.measures = Array.from(
      this.model.measureEngine.getMeasureList().filter(
        (meas: MeasureVO) => meas.vision === this.model.currentVision.code
      ).map(item => item.source)
    );

    this.model.currentVision.measureByLevel = null; // on rince les matrices
    // Object.values(this.model.currentVision.visionSteps || {}).forEach((vs: VisionStep) => {
      
    //   BaselineEngine.clearMeasureByLevel(this.model.currentVision, vs);
    //   // vs.clearMeasure();
    // });

    if (this.model.currentMeasure) {
      // prise de l'index
      let idx: number =  this.model.measureDS.getWorkedSource().indexOf(this.model.currentMeasure);
      this.multiDisp.agGrid.api.ensureIndexVisible(idx,'top');
      // console.log('scroll', idx, MeasureManager.getInstance().currentMeasure);
    }
    

  }

  /**
   * choix du mode
   * @param e : wizActionBt
   */
  public showMode(e: WizButton): void {
    // console.log('showMode', e);
    const res: string = e.data.buttonCode;
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.MEASURE_SET_MODE, res));
  }

  /**
   * Callback de selection dans la matrice
   * @param pEvent AlkEvent
   */
  private onMatrixSelectionChange(e: AlkEvent): void {
    // console.log('change from matrix', e.data);
    this.buildGraph();
  }

  /**
   * Callback de selection dans le grid, pour afficher / masquer la mesure dans la matrice
   * @param pEvent WizEvent
   */
  private onWizEventSelectionChange(e: WizEvent): void {
    // console.log('onWizEventSelectionChange', e);
    this.buildGraph();
  }

  /**
   * ouverture de la pop droite si manager.currentMeasure, sinon fermeture
   */
  private showOrHideEditionPop(): void {
    // TODO test déselection
    // NavigationEngine.getInstance().showHideRightSidePanel();
     if (this.model.currentMeasure) {
      this.model.navigationEngine.showRightSidePanel();
     } else {
      this.model.navigationEngine.hideRightSidePanel();
     }
  }

  /**
   * demande d'affichage des measures nécessaires pour ce calcul
   * @param e alkevent
   */
  private setDependency(e: AlkEvent): void {
    this.model.measureEngine.showDependency(this.model.measureEngine.currentFEI, e.data);
    this.buildGraph();
  }

  /**
   * demande d'affichage des measures héritées de ce calcul
   * @param e alkevent
   */
  private setLegacy(e: AlkEvent): void {
    // console.log('setlegacy', e.data);
    this.model.measureEngine.showLegacy(this.model.measureEngine.currentFEI, e.data);
    this.buildGraph();
  }

  /** selection des items à afficher dans la grille de thumbs */
  private doSelect(meas: MeasureVO): void {
    if (meas === this.model.currentMeasure) {
      // déselection
      this.model.currentMeasure = null;
    } else {
      this.model.currentMeasure = meas;
    }
    this.multiDisp.agGrid.api.redrawRows(); // force le rendu des lignes
    this.showOrHideEditionPop();
  }

  /**
   * Sélection d'une mesure depuis le graph
   * @param e type MEASURE_SELECT
   */
   private selectMeasure(e: AlkEvent): void {
    e.value = e.data; // # type d'event...
    this.setSelected(e);
  }

  /**
   * Callback de selection dans le grid
   * @param pEvent WizEvent
   */
   private setSelected(e: WizEvent): void {
    // empêche le changement de selection quand il y a une modification de model en cours
    if (ViewData.wizUpdateModel) {
      // on stop le fonctionnement par défaut pour afficher la pop, on sélectionnera l'item seulement si le user confirme
      e.preventDefault();

      WizPopUp.confirm(
        '$.common.pending.update.title.$',
        '$.common.pending.update.detail.$',
        this.confirmSwap.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        e.value
      ).show();
    } else {     
      this.doSelect(e.value);
    }
  }

  /**
   * Confirmation de la sélection de la BU, on met à jour la datasource puis la vue
   * On ne peut pas passer directement par le doSelectBu car la méthode est utilisée aussi
   * dans le cas ou on ne prevent pas la sélection. On ferait le toggleSelect deux fois sinon
   * @param result: Objet ConfirmationResultObj contenant le choix effectué sur la popup
   */
  private confirmSwap(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      this.doSelect(result.data);
    }
  }



  /**
   * Event de changement de mode de visu
   * @param e AlkEvent
   */
  private setMeasureMode(e: AlkEvent): void {
    this.model.currentFistMode = e.data;
    this.buildGraph();
  }

  /** dessin des éléments graphiques */
  private buildGraph(): void {
    // nettoyage
    this.canvasContainer.clear();

    this.thumbMap = new Map<string, [ComponentRef<MeasureTreeRenderer>, number, number, number, number, number]>();
    this.nextX = 0;
    // TODO ajuster la hauteur
    const goodHeight: number = this.maxPerColumn * (this.baseHeight + this.baseVGap);
    this.canvas.nativeElement.width = 4000;
    this.canvas.nativeElement.height = goodHeight;

    this.canvasDot.nativeElement.width = 4000;
    this.canvasDot.nativeElement.height = goodHeight;

    // TODO optimiser les positions pour diminuer les croisements de traits
    this.drawThumbs();
    this.cdref.markForCheck();
  }

  /** lignes > 1 */
  private drawThumbs(): void {
    let levelIdx: number = 1; // niveau de dépendance
    this.itemIdx = 1; // la mesure en cours de dessin, reset pour rebuild
    const matrixByLevel: Map<number, Map<string, MeasMode>> = 
    this.model.measureEngine.currentFEI.leveledMatrix;
    // MeasureManager.getInstance().matrixByLevel;

    // collectes des mesures sélectionnées
    const oks: MeasureVO[] = this.model.measureDS.selectedItems; // MeasureManager.instance.getMeasureAndWg().filter(item => item.filterSelected === true);
    const okMap: Map<string, MeasureVO> = new Map(oks.map((item) => [item.shortCode, item]));

    // console.log('meas', okMap);

    const visionCode: string = this.model.visionCode;
    // let posy: number = 0;
    while (matrixByLevel.has(levelIdx)) {
      // le niveau existe

      let posx: number = this.nextX;
      let posy: number = 0;
      // console.log('nextX', this.nextX);

      Array.from(matrixByLevel.get(levelIdx).keys()).forEach((key: string) => {
        // collecte des clés de niveau x
        const mode: string = key.split(ViewData.CONTEXT_SEPARATOR)[1];
        const code: string = key.split(ViewData.CONTEXT_SEPARATOR)[0];
        let mvo: MeasureVO;
        if (mode === WizConstants.MEASURE_MODE_WEIGHT_GRID) {
          // weightGrid, pas dans les measures
          mvo = this.model.measureEngine.getMeasure(
            visionCode,
            this.model.currentStepLevel,
            code,
            true
          ); // recherche dans la map de fake wgMeasure
        } else {
          // sinon mesure
          mvo = this.model.measureEngine.getMeasure(
            visionCode,
            this.model.currentStepLevel,
            code
          );
          // prise des éléments en erreur
          if (this.model.errorMMs && this.model.errorMMs.has(code)) {
            mvo.hasError = true;
          }
        }

        let linkOffset: number = (levelIdx - 1) * this.rowLineOffset; // décalage du point d'accroche pour éviter les chevauchements de traits
        if (levelIdx % 2 === 0) {
          linkOffset = linkOffset * -1;
        }

        if (mvo && mvo !== undefined) {
          // console.log('okMap', okMap, code, MeasureManager.getInstance().currentFistMode);
          if ( mode === this.model.currentFistMode || mode === WizConstants.MEASURE_MODE_CONSTANT || mode === WizConstants.MEASURE_MODE_WEIGHT_GRID) {
            if (okMap.has(code)) {
              // okMap.size === 0 || pour tout afficher sans sélection. Deprecated
              if (posy >= this.maxPerColumn) {
                posy = 0;
                posx += this.baseWidth + this.baseHGap;
              }

              const coordX = posx;
              const coordY = posy * (this.baseHeight + this.baseVGap);

              const meCompo: ComponentRef<MeasureTreeRenderer> = WizComponentManager.instance.addChildTo(
                MeasureTreeRenderer,
                this.canvasContainer,
                {
                  instanceProperties: { data: mvo },
                  styleProperties: {
                    position: 'absolute',
                    width: this.baseWidth + 'px',
                    height: this.baseHeight + 'px',
                    left: coordX + 'px',
                    top: coordY + 'px',
                  },
                }
              );
              this.thumbMap.set(mvo.shortCode, [meCompo, coordX, coordY, this.baseWidth, this.baseHeight, linkOffset]);
              posy++;
              this.nextX = coordX + (this.baseWidth + this.baseHGap); // prochaines coordonnées Y

              // on s'occupe de ses traits (key pour avoir le code#mode)
              this.linkMeImFamous(key, levelIdx);
            }
          }
        }
      });

      levelIdx++; // incrément
      this.nextX += this.levelHGap;
    }
  }

  /**
   * relier le compo a ses ancêtres
   * @param key : code#mode pour obtenir le mm
   * @param level: niveau de dépendance, commence à 1
   *
   */
  private linkMeImFamous(key: string, level: number): void {
    // collecte du compo
    const compo: [ComponentRef<MeasureTreeRenderer>, number, number, number, number, number] = this.thumbMap.get(
      key.split(ViewData.CONTEXT_SEPARATOR)[0]
    );
    // const mm: MeasMode = MeasureManager.getInstance().matrixByLevel.get(level).get(key);
    const mm: MeasMode = this.model.measureEngine.currentFEI.leveledMatrix.get(level).get(key);
    const ctx = this.canvas.nativeElement.getContext('2d'); // canvas des lignes
    const boulix = this.canvasDot.nativeElement.getContext('2d'); // canvas des boules

    const coordFrom: [number, number] = [0, 0];
    coordFrom[0] = compo[1];
    coordFrom[1] = compo[2] + compo[4] / 2 + compo[5];

    if (!!mm.deps) {
      [...mm.deps.values()].forEach((depCode: string) => {
        // uniquement si même mode ou constante ou weightgrid
        const code: string = depCode.split(ViewData.CONTEXT_SEPARATOR)[0];
        const mode: string = depCode.split(ViewData.CONTEXT_SEPARATOR)[1];

        if (
          mode === WizConstants.MEASURE_MODE_CONSTANT ||
          mode === WizConstants.MEASURE_MODE_WEIGHT_GRID ||
          mode === this.model.currentFistMode
        ) {
          const coordTo: [number, number] = this.fatBottomComponent(code);

          if (coordTo) {
            // console.log('coords', key, coordFrom[0], coordFrom[1], coordTo[0], coordTo[1]);
            const domLen: number = this.scheme.domain.length; // prise du pool de couleurs
            const colStr: string = this.scheme.domain[this.itemIdx % domLen];

            ctx.strokeStyle = colStr;
            ctx.beginPath();
            ctx.moveTo(coordFrom[0], coordFrom[1]);

            ctx.lineTo(coordTo[0], coordTo[1]);
            ctx.stroke();

            boulix.strokeStyle = colStr;
            boulix.fillStyle = colStr;
            boulix.beginPath();
            boulix.arc(coordFrom[0], coordFrom[1], 3, 0, Math.PI * 2, true);
            boulix.fill();
            boulix.stroke();
          }
        }
      });
      this.itemIdx++; // on a dessiné des traits, on change de couleur pour le prochain
    }

    // console.log('compo', compo[0].instance.data, mm);
  }

  /**
   * pour un MeasureTreeRenderer donné, obtention de son point d'accroche inférieur
   * @param code de la mesure
   * @returns [x, y]
   */
  private fatBottomComponent(code: string): [number, number] {
    let res: [number, number] = null;
    let coordX: number = 0;
    let coordY: number = 0;

    const compo: [ComponentRef<MeasureTreeRenderer>, number, number, number, number, number] = this.thumbMap.get(code);
    if (compo) {
      coordX = compo[1] + compo[3]; // origine X + width/2 + offset
      coordY = compo[2] + compo[4] / 2; // + compo[5]; // origine Y + height
      res = [coordX, coordY];
    }

    return res;
  }

  move(y: number, z: number, ctx: CanvasRenderingContext2D) {
    const max = ctx.canvas.width / z;
    const canvas = ctx.canvas;
    let x = 0;
    const i = setInterval(() => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.draw(x, y, z, ctx);
      x = x + 10;
      if (x >= max) {
        clearInterval(i);
      }
    }, 20);
  }

  draw(x: number, y: number, z: number, ctx: CanvasRenderingContext2D) {
    ctx.fillRect(z * x, z * y, z, z);
  }

  /** initialisation du filtre du multidisplay */
  private mainFilter: FilterComponent;
  private initFilter(pFilter: FilterComponent): FilterComponent {
    this.mainFilter = pFilter;
    return this.mainFilter;
  }

  /**
   * construction de la zone de filtre des mesures
   * @param event : Evenement de changement dans le text input de filtre
   */
  private buildFilter(event: WizEvent = null): void {
    // liste de filtres complémentaires
    const filter = [];
    filter.push(FilterObj.create('selected', '$.measure.filter.selected.only.$', FILTER_TYPE.TRUELEAN, false, 1));
    filter.push(FilterObj.create('editable', '$.measure.filter.editable.only.$', FILTER_TYPE.TRUELEAN, false, 2));
    filter.push(
      FilterObj.create('noDependency', '$.measure.filter.no.dependencies.$', FILTER_TYPE.TRUELEAN, false, 3)
    );

    this.mainFilter.configure(['shortCode', 'trsLabel', 'formulaI'], null, Array.from(filter));

    // le contextEngine prend le relais pour alimenter les filtres par défaut
    this._context.feedFilterContext(this.mainFilter);
  }

  /**
   * panneau droit
   */
  public rightSideContent(): any {
    return MeasureRightPop;
  }

  /** mémorisation du filtre */
  wizOnDestroy(): void {
	super.wizOnDestroy();
    // this._context.saveLocalFilter(this.mainFilter, this.code);
  }

  /**
   * appel de la pop d'édition de formule depuis une vignette ou le Fx de la popUp d'édition
   * @param e AlkEvent.MEASURE_SHOW_FORMULA, data contient [MeasureVO, mode, callback]
   */
  public showFormuleEditor(e: AlkEvent) {
    // console.log('showFormuleEditor', e.data[0], e.data[1]);
    let params: MeasureParams = e.data;
    
    let callback: Function = params.callback; // e.data[2];
    if (!callback) {
      // callback non alimentée sur click depuis le thumb, bypass
      params.callback = this.backFromPop.bind(this);
    }

    const editPop: WizPopUp = new WizPopUp(
      FormulaEditorPop,
      true,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      '700px',
      '400px',
      params
    ).show();
  }

  /**
   * retour d'édition rapide de formule
   * @param backpop any
   */
  private backFromPop(backpop: FormulaEditorPop): void {
    // prise de la données source sur backpop (ce n'est pas un clone, ici)
    const source: MeasureVO = backpop.source;
    const clone: MeasureVO = this.model.measureEngine.clone(source);
    clone['formula' + backpop.mode] = backpop.currentFormula;

    this.model.measureEngine.merge(clone, source, this.mergeCallback.bind(this));
    // console.log('back from functionPop', backpop);
  }

  /**
   * Retour de service merge
   * @param  bddPersist: MeasureVO
   * @param status le statut de retour du service
   * @return boolean: vrai si la comande est en succès
   */
  private mergeCallback(bddPersist: MeasureVO, status: string): void {
    if (status === WIZ_COMMAND_STATE.SUCCESS) {
      WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.MEASURE_RECOMPUTE, bddPersist));
    }
  }

   /** callback sur retour d'import : recharger les Freedatas */
  private backFromImport(e: AlkEvent): void {
    // console.log('backFromImport',e);
	if (e && e.data === BATCH_KIND.MEASURE) {
      new FindMeasureCommand(Model.getInstance()).configure(this.backFromReload.bind(this)) .execute();
	}
  }

  private backFromReload(e: any): void {
    // console.log('backFromReload',e);
    this.wizSynchronizeData();
  } 

  /**
   * rendu des overrides de levels
   * @param params la ligne de rendu
   * @returns son rendu par level
   */
  public getStepOverride(params: any): any {
    let me: MeasureVO = params.data;
    let res: string = '';
    let all: MeasureVO[] = this.model.measureEngine
      .getMeasureList().filter((m) => m.code === me.code && m.vision === me.vision)
      .sort((a, b) => a.stepLevel - b.stepLevel);
    if (!all) {
      all = [];
    }

    all.forEach((m) => {
      if (m.stepLevel > 0) {
        res += m.stepLevel + ' ';
      }
    });

    // console.log('stepOverrideStr', params);
    return res;
  }


}
